<template>
  <div id="renews-list">
    <table class="table" v-if="$store.state.responsive.viewDesktopLists">
      <thead class="fixheader">
        <tr>
          <th class="align-middle">
            <ThOrder :textHeader="'DNI'" :idHeader="'documentNumber'" :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrder($event)"></ThOrder>
          </th>
          <th class="align-middle">
            <ThOrder :textHeader="'Nº Contrato'" :idHeader="'contractNumber'" :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrder($event)"></ThOrder>
          </th>
          <th class="align-middle">
            <ThOrder :textHeader="'Nº Contrato antiguo'" :idHeader="'contractNumberOld'" :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrder($event)"></ThOrder>
          </th>
          <th class="align-middle">
            <ThOrder :textHeader="'Fecha de renovación'" :idHeader="'dateOfRequest'" :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrder($event)"></ThOrder>
          </th>
          <th class="align-middle">
            <ThOrder :textHeader="'Nº Tienda'" :idHeader="'storeNumber'" :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrder($event)"></ThOrder>
          </th>
          <th class="align-middle thEstado">
            <ThOrder :textHeader="'Estado solicitud'" :idHeader="'contractStatus'" :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrder($event)"></ThOrder>
          </th>
          <th class="align-middle thOperaciones"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(renew, index) in renewsAux" v-bind:key="renew.id">
          <td class="align-middle py-4">{{ renew.legalIdentifier || "-" }}</td>
          <td class="align-middle py-4">{{ renew.newContractId || "-" }}</td>
          <td class="align-middle py-4">{{ renew.parentContractId || "-" }}</td>
          <td class="align-middle py-4">{{ renew.dateOfRequest || "-" }}</td>
          <td class="align-middle py-4">{{ renew.store || "-" }}</td>
          <td class="align-middle py-4 tdEstado" :title="getTitle(renew.status.status)">
            <span v-if="renew.status.status.toUpperCase() == 'COMPLETED'"
              class="badge text-success border border-success">COMPLETADO</span>
            <span v-if="renew.status.status == 'created'" class="badge text-info border border-info">CREADO</span>
            <span v-if="renew.status.status == 'pending_customer_approval'" class="badge text-info border border-info">PENDIENTE CONFIRMACIÓN DEL CLIENTE</span>
            <span v-if="renew.status.status == 'approved_by_customer'" class="badge text-success border border-success">APROBADO POR EL CLIENTE</span>
            <span v-if="renew.status.status == 'rejected_by_customer'" class="badge text-danger border border-danger">RECHAZADO POR EL CLIENTE</span>
            <span v-if="renew.status.status == 'approved_by_bo'" class="badge text-success border border-success">APROBADO POR BO</span>
            <span v-if="renew.status.status == 'rejected_by_bo'" class="badge text-danger border border-danger">RECHAZADO POR BO</span>
            <span v-if="renew.status.status == 'reviwed_ok'" class="badge text-primary border border-primary">REVISED
              WITHOUT DEFECTS</span>
            <span v-if="renew.status.status == 'parent_contract_cancelled'" class="badge text-danger border border-danger">CONTRATO ANTERIOR CANCELADO</span>
            <span v-if="renew.status.status == 'contract_renewal_initial_payment_on_hold'" class="badge text-warning border border-warning">CUOTA INICIAL DE NUEVO CONTRATO EN HOLD</span>
            <span v-if="renew.status.status == 'renewal_fee_payment_failed'" class="badge text-danger border border-danger">COBRO DE CUOTA DE RENOVACIÓN FALLIDA</span>
            <span v-if="renew.status.status == 'renewal_fee_payment_completed'" class="badge text-success border border-success">COBRO DE CUOTA DE RENOVACIÓN EXITOSA</span>
            <span v-if="renew.status.status == 'cancelled'" class="badge text-danger border border-danger">CANCELADO</span>
            <span v-if="renew.status.status == 'pending_logistics_processing'" class="badge text-info border border-info">PROCESO DE LOGÍSTICA PENDIENTE</span>
            <span v-if="renew.status.status == 'pending_approval_available'" class="badge text-warning border border-warning">PTE ACEPTACIÓN RENOVACIÓN</span>
            <span v-if="renew.status.status == 'delivery_success'" class="badge text-success border border-success">ENTREGA ACEPTADA</span>
            <span v-if="renew.status.status == 'delivery_failure'" class="badge text-danger border border-danger">ENTREGA RECHAZADA</span>
          </td>
          <td id="operaciones" class="align-middle py-4 tdOperaciones">
            <div class="dropdown dropdown-inherit">
              <span id="dropdownOperations" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <v-icon name="fa-ellipsis-v" />
              </span>
              <div class="dropdown-menu p-0 dropdown-menu-right" aria-labelledby="dropdownOperations">
                <a class="dropdown-item py-3 px-4" href="#"
                  @click="openModals(index, renew.id, 'status', 'modalRenews')">Ver renovación</a>

                <a v-if="renew.status.status === 'pending_customer_approval'" class="dropdown-item py-3 px-4" href="#"
                  @click="openModals(index, renew.id, 'approved_by_customer', 'renewProceed')">Aceptado cliente</a>

                <a v-if="renew.status.status === 'pending_customer_approval'" class="dropdown-item py-3 px-4" href="#"
                  @click="openModals(index, renew.id, 'rejected_by_customer', 'renewProceed')">Rechazado cliente</a>

                <a v-if="renew.status.status === 'approved_by_customer'" class="dropdown-item py-3 px-4" href="#"
                  @click="openModals(index, renew.id, 'approved_by_bo', 'renewProceed')">Aceptado BO</a>

                <a v-if="renew.status.status === 'approved_by_customer'" class="dropdown-item py-3 px-4" href="#"
                  @click="openModals(index, renew.id, 'rejected_by_bo', 'renewProceed')">Rechazado BO</a>
                <a v-if="isLogisticsPending(renew.status.status)" class="dropdown-item py-3 px-4" href="#"
                  @click="openModals(index, renew.id, 'delivery_success', 'renewProceed')">Aceptar Renovación</a>
                <a v-if="isLogisticsPending(renew.status.status)" class="dropdown-item py-3 px-4" href="#"
                  @click="openModals(index, renew.id, 'delivery_failure', 'renewProceed')">Rechazar Renovación</a>
                <a v-if="isPendingApprovalAvailable(renew.status.status)" class="dropdown-item py-3 px-4" href="#"
                  @click="openModals(index, renew.id, 'approval_available_for_bo', 'renewProceed')">Aceptar Renovación</a>
                <a v-if="isPendingApprovalAvailable(renew.status.status)" class="dropdown-item py-3 px-4" href="#"
                  @click="openModals(index, renew.id, 'rejected_bo_not_available', 'renewProceed')">Rechazar Renovación</a>
                <a v-if="renew.status.status === 'renewal_fee_payment_failed'" class="dropdown-item py-3 px-4" href="#"
                  @click="openModals(index, renew.id, 'retry_renewal_fee', 'renewProceed')">Reenviar cobro renovación</a>
                <a class="dropdown-item py-3 px-4" href="#"
                  @click="openModals(index, renew.id, 'cancel_renewal', 'renewProceed')">Cancelar renovación</a>
                <!-- <a v-if="renew.status.status === 'CANCELED'" class="dropdown-item py-3 px-4" href="#"
                  @click="openModals(index, renew.id, 'status', 'renewProceed')">Cancelar</a> -->
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <template v-if="!$store.state.responsive.viewDesktopLists">
      <div class="card p-2 mb-3" v-for="(renew, index) in renewsAux" v-bind:key="renew.id">
        <div class="list-item">
          <div class="item d-flex align-items-center justify-content-between px-2 py-3" data-toggle="collapse"
            :href="'#collapseExample' + index" role="button" aria-expanded="true"
            :aria-controls="'collapseExample' + index">
            <h4 class="m-0"><strong>DNI: </strong><span>{{ renew.legalIdentifier }}</span></h4>
            <v-icon name="bi-chevron-up" />
          </div>
          <div class="collapse show ml-3 mr-2 borderFirstItem" :id="'collapseExample' + index">
            <div class="d-flex align-items-center justify-content-between mb-2 mt-2">
              <div class="d-flex align-items-center justify-content-start">
                <p class="m-0 mr-2"><strong>Nº Contrato: </strong></p><span>{{ renew.newContractId }}</span>
              </div>
              <div>
                <div class="dropdown dropdown-inherit">
                  <span id="dropdownOperations" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <v-icon name="fa-ellipsis-v" />
                  </span>
                  <div class="dropdown-menu p-0 dropdown-menu-right" aria-labelledby="dropdownOperations">
                    <a class="dropdown-item py-3 px-4" href="#"
                    @click="openModals(index, renew.id, 'status', 'modalRenews')">Ver renovación</a>
                    <a v-if="renew.status.status === 'pending_customer_approval'" class="dropdown-item py-3 px-4" href="#"
                      @click="openModals(index, renew.id, 'approved_by_customer', 'renewProceed')">Aceptado cliente</a>

                    <a v-if="renew.status.status === 'pending_customer_approval'" class="dropdown-item py-3 px-4" href="#"
                      @click="openModals(index, renew.id, 'rejected_by_customer', 'renewProceed')">Rechazado cliente</a>

                    <a v-if="renew.status.status === 'approved_by_customer'" class="dropdown-item py-3 px-4" href="#"
                      @click="openModals(index, renew.id, 'approved_by_bo', 'renewProceed')">Aceptado BO</a>

                    <a v-if="renew.status.status === 'approved_by_customer'" class="dropdown-item py-3 px-4" href="#"
                      @click="openModals(index, renew.id, 'rejected_by_bo', 'renewProceed')">Rechazado BO</a>
                    <a v-if="isLogisticsPending(renew.status.status)" class="dropdown-item py-3 px-4" href="#"
                      @click="openModals(index, renew.id, 'delivery_success', 'renewProceed')">Aceptar Renovación</a>
                    <a v-if="isLogisticsPending(renew.status.status)" class="dropdown-item py-3 px-4" href="#"
                      @click="openModals(index, renew.id, 'delivery_failure', 'renewProceed')">Rechazar Renovación</a>
                    <a v-if="isPendingApprovalAvailable(renew.status.status)" class="dropdown-item py-3 px-4" href="#"
                      @click="openModals(index, renew.id, 'approval_available_for_bo', 'renewProceed')">Aceptar Renovación</a>
                    <a v-if="isPendingApprovalAvailable(renew.status.status)" class="dropdown-item py-3 px-4" href="#"
                      @click="openModals(index, renew.id, 'rejected_bo_not_available', 'renewProceed')">Rechazar Renovación</a>
                    <a v-if="renew.status.status === 'renewal_fee_payment_failed'" class="dropdown-item py-3 px-4" href="#"
                      @click="openModals(index, renew.id, 'retry_renewal_fee', 'renewProceed')">Reenviar cobro renovación</a>
                    <a class="dropdown-item py-3 px-4" href="#"
                      @click="openModals(index, renew.id, 'cancel_renewal', 'renewProceed')">Cancelar renovación</a>
                    <!-- <a v-if="renew.status.status === 'CANCELED'" class="dropdown-item py-3 px-4" href="#"
                      @click="openModals(index, renew.id, 'status', 'renewProceed')">Cancelar</a> -->
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex align-items-center justify-content-start flex-wrap mb-2">
              <p class="m-0 mr-2"><strong>Nº Contrato antiguo: </strong></p><span>{{ renew.parentContractId }}</span>
            </div>
            <div class="d-flex align-items-center justify-content-start flex-wrap mb-2">
              <p class="m-0 mr-2"><strong>Fecha de renovación: </strong></p><span>{{ renew.dateOfRequest }}</span>
            </div>
            <div class="d-flex align-items-center justify-content-start flex-wrap mb-2">
              <p class="m-0 mr-2"><strong>Fecha de renovación: </strong></p><span>{{ renew.dateOfRequest }}</span>
            </div>
            <div class="d-flex align-items-center justify-content-start flex-wrap mb-2">
              <p class="m-0 mr-2"><strong>Nº Tienda: </strong></p><span>{{ renew.store }}</span>
            </div>
            <div class="d-flex align-items-center justify-content-start flex-wrap mb-4">
              <p class="mb-2 mr-2"><strong>Estado solicitud: </strong></p>
              <span v-if="renew.status.status.toUpperCase() == 'COMPLETED'"
                class="badge text-success border border-success">COMPLETADO</span>
              <span v-if="renew.status.status == 'created'" class="badge text-info border border-info">CREADO</span>
              <span v-if="renew.status.status == 'pending_customer_approval'" class="badge text-info border border-info">PENDIENTE CONFIRMACIÓN DEL CLIENTE</span>
              <span v-if="renew.status.status == 'approved_by_customer'" class="badge text-success border border-success">APROBADO POR EL CLIENTE</span>
              <span v-if="renew.status.status == 'rejected_by_customer'" class="badge text-danger border border-danger">RECHAZADO POR EL CLIENTE</span>
              <span v-if="renew.status.status == 'approved_by_bo'" class="badge text-success border border-success">APROBADO POR BO</span>
              <span v-if="renew.status.status == 'rejected_by_bo'" class="badge text-danger border border-danger">RECHAZADO POR BO</span>
              <span v-if="renew.status.status == 'reviwed_ok'" class="badge text-primary border border-primary">REVISED
                WITHOUT DEFECTS</span>
              <span v-if="renew.status.status == 'parent_contract_cancelled'" class="badge text-danger border border-danger">CONTRATO ANTERIOR CANCELADO</span>
              <span v-if="renew.status.status == 'contract_renewal_initial_payment_on_hold'" class="badge text-warning border border-warning">CUOTA INICIAL DE NUEVO CONTRATO EN HOLD</span>
              <span v-if="renew.status.status == 'renewal_fee_payment_failed'" class="badge text-danger border border-danger">COBRO DE CUOTA DE RENOVACIÓN FALLIDA</span>
              <span v-if="renew.status.status == 'renewal_fee_payment_completed'" class="badge text-success border border-success">COBRO DE CUOTA DE RENOVACIÓN EXITOSA</span>
              <span v-if="renew.status.status == 'cancelled'" class="badge text-danger border border-danger">CANCELADO</span>
              <span v-if="renew.status.status == 'pending_logistics_processing'" class="badge text-info border border-info">PROCESO DE LOGÍSTICA PENDIENTE</span>
              <span v-if="renew.status.status == 'pending_approval_available'" class="badge text-warning border border-warning">PTE ACEPTACIÓN RENOVACIÓN</span>
              <span v-if="renew.status.status == 'delivery_success'" class="badge text-success border border-success">ENTREGA ACEPTADA</span>
              <span v-if="renew.status.status == 'delivery_failure'" class="badge text-danger border border-danger">ENTREGA RECHAZADA</span>
            </div>
          </div>
        </div>
      </div>
    </template>
    <RenewsDetails :numContract="numContract" :statusSelected="statusSelected" :modalSelected="modalSelected"
      :id="'modalRenews'" :modalTitle="'INFORMACIÓN DE LA RENOVACIÓN'" :class="'modal-lg'"></RenewsDetails>
    <RenewProceed :renewId="numContract" :statusSelected="statusSelected" :modalSelected="modalSelected"
                  :id="'renewProceed'" :modalTitle="'CAMBIO DE ESTADO'" :class="'modal-lg'"
                  @refreshRenewalList="handleRefreshRenewalList($event)"
                  @reloadList="handleReloadList"
                  @stateChangeError="handleStateChangeFailure"></RenewProceed>

  </div>
</template>

<script>
import ThOrder from '../../Shared/ThOrder.vue';
import RenewsDetails from './RenewsDetails.vue';
import RenewProceed from './RenewProceed.vue';
import { Modal as ModalBootstrap } from "bootstrap";

export default {
  name: 'RenewsList',
  props: [
    'renews',
  ],
  emits: ['selectOrder', 'reloadList', 'notify'],
  data() {
    return {
      currentOrder: '',
      currentOrderBy: '',
      numContract: '',
      modalSelected: '',
      statusSelected: '',
      indexRenews: '',
      renewsAux: this.renews,
    };
  },
  updated() {
    this.renewsAux = this.renews
  },
  components: {
    ThOrder,
    RenewsDetails,
    RenewProceed,
  },
  methods: {
    selectOrder(value) {
      this.renewsAux = this.renewsAux.sort(function (a, b) {
        let valorA = a[value.orderBy] == null || a[value.orderBy] == undefined ? 0 : a[value.orderBy]
        let valorB = b[value.orderBy] == null || b[value.orderBy] == undefined ? 0 : b[value.orderBy]
        if (value.orderBy == "capacity") {
          valorA = parseInt(a[value.orderBy].slice(0, -2))
          valorB = parseInt(b[value.orderBy].slice(0, -2))
        }
        if (valorA < valorB) return -1
        if (valorA > valorB) return 1
      })
      if (value.order == 'DESC') this.renewsAux = this.renewsAux.reverse()
    },
    openModals: function (index, id, status, identifier) {
      console.log(id);
      this.indexRenews = index;
      this.numContract = id;
      console.log(this.numContract);
      this.statusSelected = status;
      var myModal = new ModalBootstrap(document.getElementById(identifier))
      myModal.show()
    },
    getTitle(title) {
      switch (title) {
        case 'completed':
          return 'COMPLETADO';
        case 'created':
          return 'CREADO';
        case 'pending_customer_approval':
          return 'PENDIENTE CONFIRMACIÓN DEL CLIENTE';
        case 'approved_by_customer':
          return 'APROBADO POR EL CLIENTE';
        case 'rejected_by_customer':
          return 'RECHAZADO POR EL CLIENTE';
        case 'approved_by_bo':
          return 'APROBADO POR BO';
        case 'rejected_by_bo':
          return 'RECHAZADO POR BO';
        case 'reviwed_ok':
          return 'REVISED WITHOUT DEFECTS';
        case 'parent_contract_cancelled':
          return 'CONTRATO ANTERIOR CANCELADO';
        case 'contract_renewal_initial_payment_on_hold':
          return 'CUOTA INICIAL DE NUEVO CONTRATO EN HOLD';
        case 'renewal_fee_payment_failed':
          return 'COBRO DE CUOTA DE RENOVACIÓN FALLIDA';
        case 'renewal_fee_payment_completed':
          return 'COBRO DE CUOTA DE RENOVACIÓN EXITOSA';
        case 'cancelled':
          return 'CANCELADO';
        case 'pending_logistics_processing':
          return 'PROCESO DE LOGÍSTICA PENDIENTE';
        case 'pending_approval_available':
          return 'PTE ACEPTACIÓN RENOVACIÓN';
        case 'delivery_success':
          return 'ENTREGA ACEPTADA';
        case 'delivery_failure':
          return 'ENTREGA RECHAZADA';
        default:
          return title;
      }
    },
    refreshRenewalList(item) {
      this.renewsAux[this.indexRenews].status.status = item.status;
    },
    handleRefreshRenewalList(item) {
      try {
        console.log("Evento capturado: ", item);
        this.renewsAux[this.indexRenews].status.status = item.status;
        this.$emit('notify', { message: 'El estado se cambió con éxito', type: 'success' });
      } catch (error) {
        console.error("Error actualizando la lista de renovaciones:", error);
        this.handleStateChangeFailure();
      }
    },
    handleStateChangeFailure() {
      this.$emit('notify', { message: 'Error al cambiar el estado', type: 'error' });
    },
    handleReloadList(payload) {
      const message = (payload && payload.message) || 'El estado se cambió con éxito';
      this.$emit('notify', { message, type: 'success' });
      this.$emit('reloadList', payload || {});
    },
    isLogisticsPending(status) {
      if (!status) return false;
      const normalized = String(status).toLowerCase();
      return (
        normalized === 'pending_logistics_processing' ||
        normalized === 'pending_processing_logistics' ||
        normalized === 'pending_process_logistics'
      );
    },
    isPendingApprovalAvailable(status) {
      if (!status) return false;
      return String(status).toLowerCase() === 'pending_approval_available';
    },
  },
  watch: {
    renews(newValue) {
      this.renewsAux = newValue;
    }

  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>
